(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-cartas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DNI_REGEX = /^[0-9A-Za-z]{6,12}$/; // DNI (8 dígitos) o documentos más largos, como carnet de extranjería
    var TIMEOUT_MS = 25000;

    function init(root) {
      if (root.getAttribute('data-hw-ready')) return;
      root.setAttribute('data-hw-ready', '1');

      var cfgEl = root.querySelector('[data-hw-config]');
      var cfg;
      try {
        cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        return;
      }
      var msg = cfg.messages;

      var form = root.querySelector('[data-hw-form]');
      var dniInput = form.querySelector('input[name="dni"]');
      var extraInput = form.querySelector('input[name="extra"]');
      var submitBtn = root.querySelector('[data-hw-submit]');
      var statusEl = root.querySelector('[data-hw-status]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hw-card]'));
      var resultEl = root.querySelector('[data-hw-result]');
      var resultText = root.querySelector('[data-hw-result-text]');
      var resultPrize = root.querySelector('[data-hw-result-prize]');

      var state = { dni: '', extra: '', busy: false, unlocked: false, done: false };

      function setStatus(text, type) {
        statusEl.textContent = text || '';
        statusEl.className = 'hw__status' + (type ? ' hw__status--' + type : '');
      }

      function post(payload) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);
        // text/plain evita el preflight de CORS con Google Apps Script
        return fetch(cfg.scriptUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
          signal: controller.signal
        }).then(function (res) {
          clearTimeout(timer);
          if (!res.ok) throw new Error('http ' + res.status);
          return res.json();
        }).catch(function (err) {
          clearTimeout(timer);
          throw err;
        });
      }

      function errorMessage(data) {
        var code = data && data.error;
        if (code === 'dni_invalido') return msg.invalidDni;
        if (code === 'no_encontrado' || code === 'extra_incorrecto') return msg.notFound;
        return (data && data.mensaje) || msg.error;
      }

      function shuffle(arr) {
        for (var i = arr.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
        }
        return arr;
      }

      function setFace(card, faceIdx, fallbackText) {
        var img = card.querySelector('[data-hw-face-img]');
        var fb = card.querySelector('[data-hw-face-fb]');
        var url = cfg.faces[faceIdx];
        if (url) {
          img.src = url;
          img.hidden = false;
          fb.hidden = true;
        } else {
          img.hidden = true;
          fb.hidden = false;
          fb.textContent = fallbackText || '';
        }
      }

      function lockForm() {
        dniInput.readOnly = true;
        if (extraInput) extraInput.readOnly = true;
        submitBtn.disabled = true;
      }

      function unlockCards() {
        state.unlocked = true;
        root.classList.add('is-unlocked');
        cards.forEach(function (c) { c.disabled = false; });
        cfg.faces.forEach(function (u) { if (u) { new Image().src = u; } });
        lockForm();
        setStatus(msg.choose, 'ok');
        if (cards[0]) cards[0].focus();
      }

      function reveal(data, chosenIdx, replay) {
        state.done = true;
        root.classList.remove('is-unlocked');
        root.classList.add('is-done');
        cards.forEach(function (c) { c.disabled = true; });
        lockForm();

        var faceIdx = parseInt(data.cara, 10) - 1;
        if (isNaN(faceIdx) || faceIdx < 0 || faceIdx > 2) faceIdx = chosenIdx;
        var prize = data.premio ? String(data.premio) : '';

        var chosenCard = cards[chosenIdx];
        chosenCard.classList.add('is-picked');
        setFace(chosenCard, faceIdx, prize);
        // pequeña pausa para que el navegador cargue la imagen antes de voltear
        requestAnimationFrame(function () { chosenCard.classList.add('is-flipped'); });

        var others = shuffle([0, 1, 2].filter(function (n) { return n !== faceIdx; }));
        var k = 0;
        cards.forEach(function (card, idx) {
          if (idx === chosenIdx) return;
          setFace(card, others[k], '');
          k++;
          setTimeout(function () {
            card.classList.add('is-dim');
            card.classList.add('is-flipped');
          }, 1100);
        });

        resultText.textContent = replay ? msg.alreadyPlayed : msg.win;
        resultPrize.textContent = prize;
        resultEl.hidden = false;
        setStatus('', '');
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (state.busy || state.unlocked || state.done) return;

        if (!cfg.scriptUrl) { setStatus(msg.notConfigured, 'error'); return; }

        var dni = dniInput.value.replace(/\s+/g, '');
        if (!DNI_REGEX.test(dni)) { setStatus(msg.invalidDni, 'error'); dniInput.focus(); return; }

        var extra = extraInput ? extraInput.value.trim() : '';
        if (cfg.requireExtra && !extra) { setStatus(msg.invalidExtra, 'error'); extraInput.focus(); return; }

        state.dni = dni;
        state.extra = extra;
        state.busy = true;
        submitBtn.disabled = true;
        setStatus(msg.checking, '');

        post({ action: 'validar', dni: dni, extra: extra }).then(function (data) {
          if (data && data.ok && data.estado === 'disponible') {
            unlockCards();
          } else if (data && data.ok && data.estado === 'ya_jugo') {
            reveal(data, 1, true);
          } else {
            setStatus(errorMessage(data), 'error');
            submitBtn.disabled = false;
          }
        }).catch(function () {
          setStatus(msg.error, 'error');
          submitBtn.disabled = false;
        }).then(function () {
          state.busy = false;
        });
      });

      cards.forEach(function (card, idx) {
        card.addEventListener('click', function () {
          if (!state.unlocked || state.busy || state.done) return;
          state.busy = true;
          cards.forEach(function (c) { c.disabled = true; });
          card.classList.add('is-picked');
          setStatus(msg.revealing, '');

          post({ action: 'jugar', dni: state.dni, extra: state.extra, carta: idx + 1 }).then(function (data) {
            if (data && data.ok && (data.estado === 'premio' || data.estado === 'ya_jugo')) {
              reveal(data, idx, data.estado === 'ya_jugo');
            } else {
              throw data || new Error('respuesta inválida');
            }
          }).catch(function (data) {
            var text = (data && data.ok === false) ? errorMessage(data) : msg.error;
            setStatus(text, 'error');
            card.classList.remove('is-picked');
            if (!state.done) cards.forEach(function (c) { c.disabled = false; });
          }).then(function () {
            state.busy = false;
          });
        });
      });
    }

    function initAll() {
      document.querySelectorAll('[data-hw-root]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-hw-root]');
      if (root) init(root);
    });
  })();

  // ===================================================================
  // Efecto de entrada: la sección empieza en negro y se "quema"
  // (solo visual; no toca nada de la lógica del juego)
  // ===================================================================
  (function () {
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    // Ruido para que el fuego avance de forma irregular, como papel quemándose
    function hash(x, y, s) {
      var h = (Math.imul(x, 374761393) + Math.imul(y, 668265263) + Math.imul(s, 982451653)) | 0;
      h = Math.imul(h ^ (h >>> 13), 1274126177);
      h ^= h >>> 16;
      return (h >>> 0) / 4294967296;
    }
    function noise(x, y, s) {
      var xi = Math.floor(x), yi = Math.floor(y);
      var xf = x - xi, yf = y - yi;
      var u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf);
      var a = hash(xi, yi, s), b = hash(xi + 1, yi, s);
      var c = hash(xi, yi + 1, s), d = hash(xi + 1, yi + 1, s);
      return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
    }
    function fbm(x, y, s) {
      var total = 0, amp = 0.5, freq = 1, norm = 0;
      for (var o = 0; o < 4; o++) {
        total += amp * noise(x * freq, y * freq, s + o * 31);
        norm += amp;
        amp *= 0.5;
        freq *= 2.03;
      }
      return total / norm;
    }

    function finish(root) {
      var intro = root.querySelector('[data-hw-intro]');
      if (intro && intro.parentNode) intro.parentNode.removeChild(intro);
      root.classList.remove('hw--intro', 'hw--burning');
      root.classList.add('hw--lit');
    }

    function burn(root, intro, hold, dur) {
      var maskCv = intro.querySelector('[data-hw-burn]');
      var sparkCv = intro.querySelector('[data-hw-sparks]');
      var mctx = maskCv && maskCv.getContext('2d');
      var sctx = sparkCv && sparkCv.getContext('2d');
      if (!mctx || !sctx) { finish(root); return; }

      var rect = root.getBoundingClientRect();
      var W = Math.max(1, rect.width), H = Math.max(1, rect.height);
      var small = W < 750;
      var CELL = small ? 3 : 5;
      var w = Math.ceil(W / CELL), h = Math.ceil(H / CELL);
      maskCv.width = w;
      maskCv.height = h;
      var img = mctx.createImageData(w, h), px = img.data;

      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      sparkCv.width = Math.round(W * dpr);
      sparkCv.height = Math.round(H * dpr);
      sctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      // Mapa de "combustible": el fuego nace en 3 focos y avanza con ruido
      var seed = (Math.random() * 100000) | 0;
      var aspect = W / H;
      var origins = [{ x: 0.5 + (Math.random() - 0.5) * 0.3, y: 0.55 + (Math.random() - 0.5) * 0.3, k: 1 }];
      for (var o = 0; o < 2; o++) {
        origins.push({ x: 0.12 + Math.random() * 0.76, y: 0.15 + Math.random() * 0.7, k: 1.35 + Math.random() * 0.4 });
      }
      var field = new Float32Array(w * h), min = Infinity, max = -Infinity;
      for (var y = 0; y < h; y++) {
        var v = y / h;
        for (var x = 0; x < w; x++) {
          var u = x / w, dmin = Infinity;
          for (var j = 0; j < origins.length; j++) {
            var dx = (u - origins[j].x) * aspect, dy = v - origins[j].y;
            var dd = Math.sqrt(dx * dx + dy * dy) * origins[j].k;
            if (dd < dmin) dmin = dd;
          }
          var val = dmin * 0.7 + fbm(u * 4.5 * aspect, v * 4.5, seed) * 0.55;
          field[y * w + x] = val;
          if (val < min) min = val;
          if (val > max) max = val;
        }
      }
      var range = (max - min) || 1;
      for (var n = 0; n < field.length; n++) field[n] = (field[n] - min) / range;

      // Bandas del borde: brasa brillante -> naranja -> carbón -> negro
      var GLOW = 0.028, CHAR = 0.075, TAIL = 0.025;
      var T_START = -0.012;
      var END = 1 + GLOW + CHAR + TAIL;

      function paint(t) {
        for (var i = 0, p = 0; i < field.length; i++, p += 4) {
          var d = field[i] - t, r, g, b, a, k;
          if (d < -TAIL) { r = 0; g = 0; b = 0; a = 0; }
          else if (d < 0) { k = 1 + d / TAIL; r = 255; g = 110 + 60 * k; b = 20; a = 210 * k * k; }
          else if (d < GLOW) { k = d / GLOW; r = 255; g = 238 - 130 * k; b = 180 - 165 * k; a = 255; }
          else if (d < GLOW + CHAR) { k = Math.pow((d - GLOW) / CHAR, 0.6); r = 190 - 182 * k; g = 50 - 46 * k; b = 10 - 3 * k; a = 255; }
          else { r = 5; g = 2; b = 8; a = 255; }
          px[p] = r; px[p + 1] = g; px[p + 2] = b; px[p + 3] = a;
        }
        mctx.putImageData(img, 0, 0);
      }

      // Chispas que salen del borde encendido
      var parts = [], MAXP = small ? 120 : 240, SAMPLES = small ? 80 : 150;
      function spawn(t) {
        for (var s = 0; s < SAMPLES && parts.length < MAXP; s++) {
          var idx = (Math.random() * field.length) | 0;
          var d = field[idx] - t;
          if (d < 0 || d > GLOW) continue;
          parts.push({
            x: ((idx % w) + Math.random()) * (W / w),
            y: (((idx / w) | 0) + Math.random()) * (H / h),
            vx: (Math.random() - 0.5) * 50,
            vy: -(30 + Math.random() * 110),
            life: 0,
            max: 0.5 + Math.random() * 1.1,
            size: 0.7 + Math.random() * 1.9,
            ph: Math.random() * 6.28
          });
        }
      }
      function drawSparks(dt) {
        sctx.clearRect(0, 0, W, H);
        sctx.globalCompositeOperation = 'lighter';
        for (var i = parts.length - 1; i >= 0; i--) {
          var q = parts[i];
          q.life += dt;
          if (q.life >= q.max) { parts.splice(i, 1); continue; }
          q.vy -= 60 * dt;
          q.vx += Math.sin(q.life * 9 + q.ph) * 40 * dt;
          q.x += q.vx * dt;
          q.y += q.vy * dt;
          var a = 1 - q.life / q.max;
          sctx.fillStyle = 'rgba(255,' + ((90 + 90 * a) | 0) + ',20,' + (a * 0.22).toFixed(3) + ')';
          sctx.beginPath(); sctx.arc(q.x, q.y, q.size * 3.2, 0, 6.2832); sctx.fill();
          sctx.fillStyle = 'rgba(255,' + ((200 + 50 * a) | 0) + ',' + ((120 + 100 * a) | 0) + ',' + a.toFixed(3) + ')';
          sctx.beginPath(); sctx.arc(q.x, q.y, q.size, 0, 6.2832); sctx.fill();
        }
        sctx.globalCompositeOperation = 'source-over';
      }

      var t0 = null, last = 0, burning = false, maskDone = false, endAt = 0, first = true;
      function frame(now) {
        if (t0 === null) { t0 = now; last = now; }
        var el = now - t0;
        var dt = Math.min(0.05, (now - last) / 1000);
        last = now;

        if (!maskDone) {
          var t;
          if (el < hold) {
            // Fase en negro: unas brasas apenas laten antes de prender
            t = T_START + Math.sin(el / 70) * 0.006;
          } else {
            if (!burning) { burning = true; root.classList.add('hw--burning'); }
            var p = Math.min(1, (el - hold) / dur);
            t = T_START + Math.pow(p, 1.35) * (END - T_START); // el fuego acelera
            if (p >= 1) { maskDone = true; endAt = now; }
          }
          paint(t);
          if (first) { first = false; intro.classList.add('is-live'); }
          if (!maskDone) spawn(t);
        }
        drawSparks(dt);

        if (maskDone && (parts.length === 0 || now - endAt > 900)) {
          intro.classList.add('is-out');
          setTimeout(function () { finish(root); }, 450);
          return;
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function play(root) {
      if (root.getAttribute('data-hw-intro-ready')) return;
      root.setAttribute('data-hw-intro-ready', '1');
      var intro = root.querySelector('[data-hw-intro]');
      if (!intro) return;
      root.classList.add('hw--intro-js');

      var hold = parseInt(root.getAttribute('data-hw-intro-hold'), 10);
      var dur = parseInt(root.getAttribute('data-hw-intro-duration'), 10);
      if (isNaN(hold) || hold < 0) hold = 600;
      if (isNaN(dur) || dur < 300) dur = 2200;

      if (reduceMotion) {
        intro.classList.add('is-out');
        setTimeout(function () { finish(root); }, 450);
        return;
      }

      var go = function () {
        try { burn(root, intro, hold, dur); } catch (e) { finish(root); }
      };

      // Arranca cuando la sección entra en pantalla
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) { io.disconnect(); go(); break; }
          }
        }, { threshold: 0.2 });
        io.observe(root);
      } else {
        go();
      }
    }

    function playAll() {
      document.querySelectorAll('[data-hw-root]').forEach(play);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', playAll);
    } else {
      playAll();
    }

    // En el editor de Shopify la sección se recarga en cada cambio:
    // ahí no repetimos el quemado para que puedas editar tranquilo.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-hw-root]');
      if (!root) return;
      root.setAttribute('data-hw-intro-ready', '1');
      root.classList.add('hw--intro-js');
      finish(root);
    });
  })();

  // ===================================================================
  // Botón de WhatsApp para reclamar el premio
  // Cuando aparece el resultado, arma el mensaje con el DNI y el premio.
  // (no toca la lógica del juego: solo lee lo que ya está en pantalla)
  // ===================================================================
  (function () {
    function waNumber(raw) {
      var n = String(raw || '').replace(/\D/g, '');
      if (n.length === 9 && n.charAt(0) === '9') n = '51' + n; // celular peruano sin código de país
      return n;
    }

    function wire(root) {
      var claim = root.querySelector('[data-hw-claim]');
      var result = root.querySelector('[data-hw-result]');
      if (!claim || !result || claim.getAttribute('data-hw-claim-ready')) return;
      claim.setAttribute('data-hw-claim-ready', '1');

      var link = claim.querySelector('[data-hw-claim-link]');
      var dniInput = root.querySelector('input[name="dni"]');
      var prizeEl = root.querySelector('[data-hw-result-prize]');
      var number = waNumber(claim.getAttribute('data-hw-wa'));

      function update() {
        if (result.hidden || !link) return;
        var dni = dniInput ? dniInput.value.replace(/\s+/g, '') : '';
        var premio = prizeEl ? prizeEl.textContent.trim() : '';
        var text = (claim.getAttribute('data-hw-wa-msg') || '')
          .replace(/\{dni\}/g, dni)
          .replace(/\{premio\}/g, premio);
        link.href = 'https://wa.me/' + number + (text ? '?text=' + encodeURIComponent(text) : '');
      }

      link.href = 'https://wa.me/' + number;
      new MutationObserver(update).observe(result, { attributes: true, attributeFilter: ['hidden'] });
      update();
    }

    function wireAll() {
      document.querySelectorAll('[data-hw-root]').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wireAll);
    } else {
      wireAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-hw-root]');
      if (root) wire(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
